import type { StyleConfig } from "@stytch/vanilla-js";

export const makeStytchB2BStyle = (hideHeaderText = false): StyleConfig => ({
  fontFamily: "Inter, system-ui, sans-serif",
  hideHeaderText: hideHeaderText,
  logo: {},
  container: {
    width: "100%",
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderRadius: "0",
  },
  colors: {
    primary: "var(--primary)",
    secondary: "var(--muted-foreground)",
    success: "rgb(34, 197, 94)",
    error: "var(--destructive)",
  },
  buttons: {
    primary: {
      backgroundColor: "var(--background)",
      textColor: "var(--primary)",
      borderColor: "var(--border)",
      borderRadius: "9999rem",
    },
    secondary: {
      backgroundColor: "var(--background)",
      textColor: "var(--primary)",
      borderColor: "var(--border)",
      borderRadius: "9999rem",
    },
  },
  inputs: {
    borderColor: "var(--input)",
    borderRadius: "9999rem",
    textColor: "var(--foreground)",
    placeholderColor: "var(--muted-foreground)",
    backgroundColor: "var(--background)",
  },
});

export const makeStytchB2BStyleIframe = (): StyleConfig => ({
  fontFamily: "Inter, system-ui, sans-serif",
  hideHeaderText: true,
  logo: {},
  container: {
    width: "100%",
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderRadius: "0",
  },
  colors: {
    primary: "var(--primary)",
    secondary: "var(--muted-foreground)",
    success: "rgb(34, 197, 94)",
    error: "var(--destructive)",
  },
  buttons: {
    primary: {
      backgroundColor: "var(--background)",
      textColor: "var(--primary)",
      borderColor: "var(--border)",
      borderRadius: "9999rem",
    },
    secondary: {
      backgroundColor: "var(--background)",
      textColor: "var(--primary)",
      borderColor: "var(--border)",
      borderRadius: "9999rem",
    },
  },
  inputs: {
    borderColor: "var(--input)",
    borderRadius: "9999rem",
    textColor: "var(--foreground)",
    placeholderColor: "var(--muted-foreground)",
    backgroundColor: "var(--background)",
  },
});
